/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAccordionPanelFragment, AccordionPanelFragment, FullAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel';

/**
 * Get a single AccordionPanel by ID (base - scalars only)
 */
export const getBaseAccordionPanelById = gql`
  ${BaseAccordionPanelFragment}

  query GetBaseAccordionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    accordionPanel(id: $id, locale: $locale, preview: $preview) {
      ...BaseAccordionPanelFragment
    }
  }
`;

/**
 * Get a single AccordionPanel by ID (standard - 1 level deep)
 */
export const getAccordionPanelById = gql`
  ${AccordionPanelFragment}

  query GetAccordionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    accordionPanel(id: $id, locale: $locale, preview: $preview) {
      ...AccordionPanelFragment
    }
  }
`;

/**
 * Get a single AccordionPanel by ID (full - 2 levels deep)
 */
export const getFullAccordionPanelById = gql`
  ${FullAccordionPanelFragment}

  query GetFullAccordionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    accordionPanel(id: $id, locale: $locale, preview: $preview) {
      ...FullAccordionPanelFragment
    }
  }
`;

/**
 * Get all AccordionPanel entries with pagination (base - scalars only)
 */
export const getBaseAccordionPanels = gql`
  ${BaseAccordionPanelFragment}

  query GetBaseAccordionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionPanelOrder]
    $where: AccordionPanelFilter
    $preview: Boolean
  ) {
    accordionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseAccordionPanelFragment
      }
    }
  }
`;

/**
 * Get all AccordionPanel entries with pagination (standard - 1 level deep)
 */
export const getAccordionPanels = gql`
  ${AccordionPanelFragment}

  query GetAccordionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionPanelOrder]
    $where: AccordionPanelFilter
    $preview: Boolean
  ) {
    accordionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...AccordionPanelFragment
      }
    }
  }
`;

/**
 * Get all AccordionPanel entries with pagination (full - 2 levels deep)
 */
export const getFullAccordionPanels = gql`
  ${FullAccordionPanelFragment}

  query GetFullAccordionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionPanelOrder]
    $where: AccordionPanelFilter
    $preview: Boolean
  ) {
    accordionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullAccordionPanelFragment
      }
    }
  }
`;
